module.exports = __webpack_public_path__ + "static/media/activity_type_kinderen_inverted.dd3fc9c7.svg";